import { __awaiter, __generator } from "tslib";
var SUPERFLOW_SDK_VERSION = 'latest';
var loadSuperflow = function (options, queryParams) {
    return new Promise(function (resolve, reject) {
        var superflowScriptId = 'superflowToolbarScript';
        var existingScript = document.getElementById(superflowScriptId);
        var staging = false;
        var version = 'latest';
        if (options) {
            if (options.staging) {
                staging = options.staging;
            }
            if (options.version) {
                version = options.version;
            }
        }
        if (!(options === null || options === void 0 ? void 0 : options.version)) {
            version = SUPERFLOW_SDK_VERSION;
        }
        if (!existingScript) {
            var script = document.createElement('script');
            var src = "https://cdn.jsdelivr.net/npm/@usesuperflow/toolbar".concat(staging ? '-staging' : '', "@").concat(version, "/superflow.min.js");
            // set query params in script url
            if (queryParams) {
                var params = new URLSearchParams(queryParams);
                src = "".concat(src, "?").concat(params.toString());
            }
            script.src = src;
            script.id = superflowScriptId;
            script.async = true;
            script.setAttribute('data-sf-platform', 'superflow-client');
            document.body.appendChild(script);
            script.onload = function () {
                // Resolve the promise when the script has loaded
                resolve();
            };
            script.onerror = function () {
                // Reject the promise if there is an error loading the script
                reject(new Error('Failed to load Superflow script'));
            };
        }
        else {
            // Resolve the promise immediately if the script already exists.
            resolve();
        }
    });
};
export var initSuperflow = function (apiKey, config) { return __awaiter(void 0, void 0, void 0, function () {
    var queryParams, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                if (!apiKey) {
                    throw new Error('API Key is required');
                }
                queryParams = {};
                queryParams.apiKey = apiKey;
                if (config === null || config === void 0 ? void 0 : config.projectVersionKey) {
                    queryParams.projectVersionKey = config.projectVersionKey;
                }
                if (config === null || config === void 0 ? void 0 : config.projectId) {
                    queryParams.projectId = config.projectId;
                }
                return [4 /*yield*/, loadSuperflow(config === null || config === void 0 ? void 0 : config.options, queryParams)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                console.error(err_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
